"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.modules = exports.formats = exports.CustomModules = exports.CustomFormats = void 0;
var _reactQuill = require("react-quill");
var _quillImageResizeModuleReact = _interopRequireDefault(require("quill-image-resize-module-react"));
_reactQuill.Quill.register('modules/imageResize', _quillImageResizeModuleReact.default);
const modules = exports.modules = {
  toolbar: [
  // explicitly list font keys so the toolbar dropdown shows these options
  [{
    header: '1'
  }, {
    header: '2'
  }, {
    font: ['arial', 'comic-sans', 'courier-new', 'georgia', 'helvetica', 'lato', 'lucida', 'montserrat', 'noto-sans', 'open-sans', 'poppins', 'roboto', 'segoe-ui', 'source-sans-pro', 'times-new-roman', 'trebuchet-ms', 'verdana']
  }], [{
    size: []
  }], ['bold', 'italic', 'underline', 'strike', 'blockquote', 'code-block'], [{
    list: 'ordered'
  }, {
    list: 'bullet'
  }, {
    indent: '-1'
  }, {
    indent: '+1'
  }], ['link', 'image', 'video'], [{
    script: 'sub'
  }, {
    script: 'super'
  }], [{
    direction: 'rtl'
  }], [{
    color: []
  }, {
    background: []
  }], [{
    align: []
  }], ['clean']],
  imageResize: {
    parchment: _reactQuill.Quill.import('parchment'),
    modules: ['Resize', 'DisplaySize', 'Toolbar']
  },
  history: {
    delay: 500,
    maxStack: 100,
    userOnly: true
  }
};
const formats = exports.formats = ['header', 'font', 'size', 'bold', 'italic', 'underline', 'strike', 'blockquote', 'list', 'bullet', 'indent', 'link', 'image', 'video', 'width', 'code-block', 'code', 'script', 'direction', 'formula', 'color', 'background', 'align', 'Resize', 'DisplaySize', 'parchment'];

// Modules object for setting up the Quill editor
const CustomModules = exports.CustomModules = {
  toolbar: {
    container: '#toolbar'
  },
  history: {
    delay: 500,
    maxStack: 100,
    userOnly: true
  }
};

// Formats objects for setting up the Quill editor
const CustomFormats = exports.CustomFormats = ['header', 'font', 'size', 'bold', 'italic', 'underline', 'align', 'strike', 'script', 'blockquote', 'background', 'list', 'bullet', 'indent', 'link', 'image', 'color', 'code-block'];
const Size = _reactQuill.Quill.import('formats/size');
Size.whitelist = ['extra-small', 'small', 'medium', 'large'];
_reactQuill.Quill.register(Size, true);

// Add fonts to whitelist and register them
const Font = _reactQuill.Quill.import('formats/font');
// expanded list of fonts (keys are the values Quill will use — map to CSS classes below)
Font.whitelist = ['arial', 'comic-sans', 'courier-new', 'georgia', 'helvetica', 'lato', 'lucida', 'montserrat', 'noto-sans', 'open-sans', 'poppins', 'roboto', 'segoe-ui', 'source-sans-pro', 'times-new-roman', 'trebuchet-ms', 'verdana'];
_reactQuill.Quill.register(Font, true);